import styled from 'styled-components';

import vw from 'src/styles/utils';

export const QuestionnaireLabel = styled.label`
  font-family: proxima-nova, sans-serif !important;
  text-transform: uppercase;
  color: #000000;
  text-align: left;
  ${vw('font-size', 13, 16)};
  .error {
    color: red;
  }
`;
